import styled from "styled-components";
interface Props {
}
export const Content = styled.div<Props>`
  .loading{
    margin: 50px 0px;
  }
`;
